import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { TabularTypeDatasetAdapter, tabularTypeDatasetWithDatabaseAdapts } from './tabular-type.dataset.adapter';

import { MountedRelationalDatabaseTableDataset } from 'shell-models-lib';


@AdapterRegistry.adapter({
    model: Metamodel.modelFor(MountedRelationalDatabaseTableDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetWithDatabaseAdapts
})
export class MountedRelationalDatabaseDatasetAdapter extends TabularTypeDatasetAdapter<MountedRelationalDatabaseTableDataset, Model.DatasetResource> {
    protected async _toResource(dataset: MountedRelationalDatabaseTableDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(MountedRelationalDatabaseTableDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: MountedRelationalDatabaseTableDataset): Promise<MountedRelationalDatabaseTableDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, MountedRelationalDatabaseTableDataset.MODEL);
    }
}
